/* eslint-disable no-shadow */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { addStep, clearStep, popStep } from '../actions/Breadcrumbs';
import { getCompanies } from '../actions/Companies';
import { setGlobalIsBoxTab } from '../actions/Globals';
import { toggleCollapse } from '../actions/User';
import Header from './Header/Header';
import { useUnifiedFetch } from '../hooks';
import axios from 'axios';
import { logout } from '../actions/User';

const url = require('url');

let count = 1;
const PrivateRoute = ({
  component: Component,
  user,
  roles,
  getCompanies,
  addStep,
  clearStep,
  toggleCollapse,
  popStep,
  setGlobalIsBoxTab,
  intervalId,
  logout,
  ...rest
}) => {
  const history = useHistory();
  const resetPassword = localStorage.getItem('resetPassword');
  // const {
  //   isLoading,
  //   data: cookieData,
  //   fetchData: getCookies,
  //   error: getCookiesError
  // } = useUnifiedFetch(`users/get-cookie`, true, true);


  useEffect(() => {
    const parseReset = JSON.parse(resetPassword);
    if (parseReset) {
      history.push('/profile?resetPassword');
    } else {
      // console.log('get response: get called',);
      // getCookies()
    }
  }, []);
  // useEffect(() => {
  //   const checkUserSession = () => {
  //     if (cookieData?.status == false) {
  //       logout(localStorage.getItem('jwtToken'), intervalId);
  //       // window.location.reload()
  //     }
  //   }
  //   cookieData && cookieData?.status && checkUserSession()
  // }, [cookieData,])

  useEffect(() => {
    const urlObj = url.parse(document.location.href, true);
    const activeTab = urlObj.pathname.replace('/', '');

    setGlobalIsBoxTab(urlObj?.pathname.includes('/boxes'));
    if (!global.backStatus && history.action === 'POP' && urlObj.pathname === '/boxes') {
      popStep();
    }
    if (urlObj.pathname === '/boxes') {
      global.backStatus = false;
    } else {
      global.myEpik = 'No';
    }
    toggleCollapse(false);
    if (urlObj.query.company) {
    } else {
      if (urlObj.pathname === '/boxes' && count === 1) {
        count = 2;
        clearStep();
        addStep({ label: activeTab, redirect: '/' + activeTab });
      } else {
        if (urlObj.pathname !== '/boxes') {
          count = 1;
          clearStep();
          addStep({ label: activeTab, redirect: '/' + activeTab });
        }
      }
    }

    if (user.role === 'superAdmin') {
      getCompanies(localStorage.getItem('jwtToken'), undefined, 'yes', 'none', true);
    }
    if (
      user.role === 'companyGroupAdmin' ||
      (user.role === 'companyGroupManager' && localStorage.getItem('jwtToken'))
    ) {
      getCompanies(localStorage.getItem('jwtToken'), undefined, 'yes', '', true);
    }
  }, [roles]);

  return (
    <Route
      {...rest}
      render={props =>
        localStorage.getItem('jwtToken') ? (
          <Header>
            <Component {...props} roles={roles} />
          </Header>
        ) : <Redirect to="/login" />
      }
    />
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
  intervalId: state.UIState.users.intervalId
});
const mapDispatchToProps = dispatch => ({
  getCompanies: (token, pagination, disablePaginate, type, onlyName) =>
    dispatch(getCompanies(token, pagination, disablePaginate, type, undefined, onlyName)),
  addStep: step => dispatch(addStep(step)),
  clearStep: () => dispatch(clearStep()),
  popStep: () => dispatch(popStep()),
  toggleCollapse: val => dispatch(toggleCollapse(val)),
  setGlobalIsBoxTab: body => dispatch(setGlobalIsBoxTab(body)),
  logout: (token, interval) => dispatch(logout(token, interval)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivateRoute);
